import { render, staticRenderFns } from "./PO-Received-Serial-Dialog.vue?vue&type=template&id=38dd84a2&scoped=true"
import script from "./PO-Received-Serial-Dialog.vue?vue&type=script&lang=js"
export * from "./PO-Received-Serial-Dialog.vue?vue&type=script&lang=js"
import style0 from "./PO-Received-Serial-Dialog.vue?vue&type=style&index=0&id=38dd84a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd84a2",
  null
  
)

export default component.exports